module.exports = __webpack_public_path__ + "static/media/checked_radio.bd09eda8.svg";